// Account
export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const UPDATE_LOGGED_IN_USER = "UPDATE_LOGGED_IN_USER";
export const REMOVE_LOGGED_IN_USER = "REMOVE_LOGGED_IN_USER";
export const SET_FORGOT_USER = "SET_FORGOT_USER";
export const TOGGLE_CLASS_ACTION = "TOGGLE_CLASS_ACTION";
export const SET_COMMON_DATA = "SET_COMMON_DATA";
export const SET_SITE_SETTINGS = "SET_SITE_SETTINGS";
export const RELOAD_PROFILE_DATA = "RELOAD_PROFILE_DATA";